import React, { useState, useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'

import {useSelector} from 'react-redux'
import {ServerConfig} from 'config'
import axios from 'axios'


// nodejs library to set properties for components
import PropTypes from 'prop-types'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid, Hidden, Container } from '@material-ui/core'
import { ListGroup, ListGroupItem } from 'reactstrap';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import Box from "@material-ui/core/Box";

// components
import _, { get } from 'lodash'
import { hasPermission } from 'utils/hasPermission';

import Page from 'components/Page/Page'

import Products from './Products.js'
import Orders from './Orders.js'

const useStyles = makeStyles((theme) => ({ }))

const ShopPage = (props) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if(!auth.access_token){
    return <Redirect to="/login" />
  }

  const isAdmin = hasPermission(auth.permissions, ['Admin', 'admin']);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  return (
    <Page title="Shop">
        <Container maxWidth={false}>

        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
            <Tab label="Products" />
            <Tab label="Orders" />
          </Tabs>
        </AppBar>
        {
          isAdmin && (
            <> 
              <TabPanel value={value} index={0}>
                <Products />
              </TabPanel>

              <TabPanel value={value} index={1}>
                <Orders />
              </TabPanel>
            </>
          )
        }
        </Container>
    </Page>
  )
}

export default ShopPage

ShopPage.propTypes = {
  children: PropTypes.node
}
